import { render, staticRenderFns } from "./CustomersImportCampaignList.vue?vue&type=template&id=6d933abf&scoped=true&"
import script from "./CustomersImportCampaignList.vue?vue&type=script&lang=ts&"
export * from "./CustomersImportCampaignList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersImportCampaignList.vue?vue&type=style&index=0&id=6d933abf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d933abf",
  null
  
)

export default component.exports